import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import { useAuthStore } from '@/stores/auth'
import { useSearchStore } from '@/stores/search'
import { ROUTER_NAMES } from '@/util/router-names.constants'
import { useFilterStore } from '@/stores/filters'

const routes = [
  {
    path: '/',
    name: ROUTER_NAMES.HOME,
    component: HomeView
  },
  {
    path: '/assessment/:id',
    name: ROUTER_NAMES.ASSESSMENT_DETAIL_PAGE,
    component: () => import('../views/AssessmentDetailView.vue')
  },
  {
    path: '/error',
    name: ROUTER_NAMES.ERROR,
    component: () => import('../views/ErrorVue.vue'),
    props: true
  },
  {
    path: '/filtersPreset',
    name: ROUTER_NAMES.PRESET_FILTERS,
    component: () => import('../views/FilterPresetsView.vue')
  }
]

// Conditionally add the dev-tools route
if (['dev', 'local', 'docker'].includes(import.meta.env.VITE_ENV)) {
  routes.push({
    path: '/devtools',
    name: ROUTER_NAMES.DEV_TOOLS,
    component: () => import('../views/DevToolsView.vue'),
    props: true
  })
}

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL),
  routes: routes
})

router.beforeEach(async (to: any, _from, next) => {
  const authStore = useAuthStore()
  const filterStore = useFilterStore()

  if (authStore.userExistsInSession() && !authStore.user) {
    await authStore.loadUserFromStorage()
  }

  const userHasPresetFilters = authStore.userCanAccess()
    ? await filterStore.fetchPreSelectedFiltersIfExists()
    : false

  if (to?.query?.search) {
    const searchStore = useSearchStore()
    searchStore.initializeFromQuery(to.query)
    next()
  } else if (to.name === 'filtersPreset' && userHasPresetFilters) {
    next({ name: 'home' })
  } else if (to.name !== 'filtersPreset' && !userHasPresetFilters) {
    next({ name: 'filtersPreset' })
  } else {
    next()
  }
})

export default router
